import styled from 'styled-components';

import {
  flexbox,
  flexDirection,
  alignItems,
  justifyContent
} from '../../../../../styles/helpers/flexbox';

export const StudentResultCellWrapper = styled.div((props) => {
  const { palette } = props.theme;

  return `
    ${flexbox()};
    ${flexDirection('column')};
    ${alignItems('center')};

    width: 200px;
    height: 70px;

    color: ${palette.primary.dark};
  `;
});

export const Title = styled.div`
  ${flexbox()};

  width: 100%;
  font-size: 12px;
  font-weight: 800;
  text-align: left;
  text-rendering: geometricPrecision;
`;

export const Content = styled.div((props) => {
  const { colours } = props.theme;

  return `
  ${flexbox()};
  ${justifyContent('center')};
  ${alignItems('center')};

  width: 100%;
  height: 25px;
  font-size: 12px;
  border: 1px solid ${colours.grey[300]};
  border-radius: 4px;
  padding-top: 3px;
`;
});

export const IconWrapper = styled.div`
  margin-right: 10px;
  margin-bottom: 2px;
  width: 20px;
  height: 20px;
`;



// WEBPACK FOOTER //
// ./components/student-list/student-modal/student-result/student-result-cell/student-result-cell.styled.js